import React from 'react';
import AutoSuggest from "@Features/autosuggest/components/AutoSuggest";
import FormSuggestion from "@Form/features/stations/components/FormSuggestion";
import useFormStationInputAutoSuggest from "@Form/features/stations/hooks/useFormStationInputAutoSuggest";
import Translation from "@Translation/components/Translation";
import IconLocationMarker from "@Icons/IconLocationMarker";
import {useTranslation} from "@Translation/hooks/useTranslation";
import PopularDestinationsNotice from "@Form/components/PopularDestinationsNotice";
import useIsMobile from "@Hooks/selector/useIsMobile";
import FormInputError from "@Form/components/FormInputError";
import StationInputFieldType from "@Form/types/StationInputField.type";
import {FormVersionType} from "@Form/types/FormVersion.type";
import getFormVersionClassNameAggregator from "@Form/functions/getFormVersionClassNameAggregator";
import TravelingDotComStationSwitchButton from "@Form/components/TravelingDotComStationSwitchButton";
import {Colors} from "@Styles/Colors.style";

interface FormStationInputFieldProps {
    stationObject: StationInputFieldType,
    direction: "departure" | "destination",
    formVersion?: FormVersionType,
}

function FormStationInputField({stationObject, direction, formVersion = "1"}: FormStationInputFieldProps) {
    const autoSuggestModel = useFormStationInputAutoSuggest(direction, stationObject)
    const isMobile = useIsMobile()
    const isDeparture = direction === 'departure'
    const directionLabel = isDeparture ? 'form.departure.label' : 'form.destination.label'
    const className = isDeparture ? '--from' : '--to'
    const placeholder = useTranslation(isDeparture ? "form.departure.placeholder" : "form.destination.placeholder")
    const {v} = getFormVersionClassNameAggregator(formVersion)

    return (
        <div className={`gb--search${v()}__select gb--search${v()}__select${className}`}>
            <span className={`gb--search${v()}__select--label`}>
                <Translation translationKey={directionLabel}/>
            </span>
            <IconLocationMarker
                className={`gb--search${v()}__select--icon`}
                height="14"
                fill={Colors.primaryColor}
            />
            <AutoSuggest
                autoFocus={isMobile}
                autoSuggestModel={autoSuggestModel}
                placeholder={placeholder}
                suggestionComponent={<FormSuggestion/>}
                decorationComponent={(
                    <PopularDestinationsNotice
                        stationLabel={autoSuggestModel?.updateContext?.label}
                    />
                )}
            />
            <FormInputError
                direction={direction}
            />
            {isDeparture && !isMobile && (
                <TravelingDotComStationSwitchButton/>
            )}
        </div>
    );
}

export default FormStationInputField;